module.exports = __webpack_public_path__ + "static/media/grid-alt.0a9c6e9c.svg";